import { CLASS_NAMES, EVENTS } from '@bs/constants';
import { MessageBus } from '@bs/utils';
/**
 * A class for the Card module
 */
export default class ListingCards extends MessageBus {
  /**
   * Constructor function of the CardFunc class. Must receive one arguments, a DOM
   * node representing a delivery ticket.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    /**
     * DOM node that is passed into the constructor
     * @property {object} element DOM node that is passed into the constructor
     */
    this.element = element;

    // Initialize the view
    this.init();
  }

  /**
   * Initializes the view by calling the functions to
   * create DOM references, setup event handlers and
   * then create the event listeners
   * @returns {object} CardFunc A reference to the current instance of the class
   * @chainable
   */
  init() {
    this.cacheDomReferences().setupHandlers().enable();
    return this;
  }

  /**
   * Cache DOM References
   *
   * Find all necessary DOM elements used in the view and cache them
   * @returns {object} CardFunc A reference to the current instance of the class
   * @chainable
   */
  cacheDomReferences() {
    this.card = this.element;
    this.card_eyebrow = this.card.querySelector(`.${CLASS_NAMES.CARD_EYEBROW}`);
    return this;
  }

  /**
   * Create event handlers to enable interaction with view
   * @returns {object} Search A reference to the current instance of the class
   * @chainable
   */
  enable() {
    if (this.card) {
      this.card.addEventListener(
        EVENTS.MOUSEENTER,
        this.onMouseEnterCardHandler
      );
      this.card.addEventListener(
        EVENTS.MOUSELEAVE,
        this.onMouseLeaveCardHandler
      );
    }
    if (this.card_eyebrow) {
      this.card_eyebrow.addEventListener(
        EVENTS.MOUSEENTER,
        this.onMouseEnterEyebrowHandler
      );
      this.card_eyebrow.addEventListener(
        EVENTS.MOUSELEAVE,
        this.onMouseLeaveEyebrowHandler
      );
    }
    return this;
  }

  /**
   * Bind event handlers with the proper context of `this`.
   * @returns {object} A reference to the current instance of the class
   * @chainable
   */
  setupHandlers() {
    this.onMouseEnterCardHandler = (event) => this.onMouseEnterCard(event);
    this.onMouseLeaveCardHandler = (event) => this.onMouseLeaveCard(event);
    this.onMouseEnterEyebrowHandler = (event) =>
      this.onMouseEnterEyebrow(event);
    this.onMouseLeaveEyebrowHandler = (event) =>
      this.onMouseLeaveEyebrow(event);
    return this;
  }

  onMouseEnterCard(event) {
    event.target.classList.add(CLASS_NAMES.LISTING_CARDS_HOVER);
    return this;
  }

  onMouseLeaveCard(event) {
    event.target.classList.remove(CLASS_NAMES.LISTING_CARDS_HOVER);
    return this;
  }

  onMouseEnterEyebrow(event) {
    event.target.classList.add(CLASS_NAMES.LISTING_CARDS_EYEBROW_HOVER);
    this.card.classList.remove(CLASS_NAMES.LISTING_CARDS_HOVER);
    return this;
  }

  onMouseLeaveEyebrow(event) {
    event.target.classList.remove(CLASS_NAMES.LISTING_CARDS_EYEBROW_HOVER);
    if (this.card.contains(event.relatedTarget)) {
      this.card.classList.add(CLASS_NAMES.LISTING_CARDS_HOVER);
    }
    return this;
  }
}
